import {main_phaser} from "./MadnesApp";
import {madnes_add_audio_to_sounds, madnes_audio_ready} from "./madnes_audio";
import * as MV from "./madnes_variables";
import {getUrl} from "./madnes";
import {systemConfig} from "./madnes_variables";
import {CONFIG_PARAMS} from "../../system/SystemConfig";
import {isLocalhost} from "../../helpers";

const madnes_loaders = {};

export function madnes_loader_create(name) {
    madnes_loaders[name] = new Phaser.Loader(main_phaser);

    madnes_loaders[name].crossOrigin = "anonymous";
    madnes_loaders[name].madnes = {};
    madnes_loaders[name].madnes.audio_cache = {};
    madnes_loaders[name].madnes.decode_complete = false;
    madnes_loaders[name].madnes.onComplete = function() {};

    (function(name)
    {
        madnes_loaders[name].onLoadComplete.add(function()
        {
            var audios = Object.keys(madnes_loaders[name].madnes.audio_cache);

            if(audios.length) //on decode audio if exists
            {
                for(var i = 0; i < audios.length; i++) {
                    madnes_add_audio_to_sounds(audios[i]);
                }

                madnes_audio_ready(audios, function()
                {
                    madnes_loaders[name].madnes.decode_complete = true;
                    madnes_loaders[name].madnes.onComplete();
                });
            }
            else
            {
                madnes_loaders[name].madnes.onComplete();
            }
        });
    } (name));

}

export function madnes_loader_start(name)
{
    madnes_loaders[name].start();
}

export function madnes_loader_set_oncomplete(name, callback)
{
    madnes_loaders[name].madnes.onComplete = callback;
}

export function madnes_loader_completed(name)
{
    if(typeof madnes_loaders[name] === 'undefined')
    {
        return false;
    }

    if(Object.keys(madnes_loaders[name].madnes.audio_cache).length) //contains audio? -> need to decode
    {
        return madnes_loaders[name].hasLoaded && madnes_loaders[name].madnes.decode_complete;
    }
    else
    {
        return madnes_loaders[name].hasLoaded;
    }
}

export function madnes_loader_add_audio(loader_name, audio_name, url)
{
    madnes_load_audio(audio_name, url, madnes_loaders[loader_name]);
    madnes_loaders[loader_name].madnes.audio_cache[audio_name] = null;
}

export function madnes_loader_add_json_atlas(loader_name, json_name, img_url, json_url)
{
    madnes_load_atlas(json_name, img_url, json_url, madnes_loaders[loader_name]);
}

export function madnes_load_audio(name, url, loader = main_phaser.load) {

    if(main_phaser.device.iOS) {
        url = getCdnUrl(url.replace(".ogg",".m4a"));
    } else {
        url = [
            getCdnUrl(url),
            getCdnUrl(url.replace(".ogg",".mp3")/*, url.replace(".ogg", ".wav?v="+ver)*/)
        ];
    }

    loader.audio(name, url);
}

export function madnes_load_json(name, url) {
    main_phaser.load.json(name, getCdnUrl(url));
}

export function madnes_load_image(name, url, loader = main_phaser.load) {
    let w = -1, h = -1;

    for(let spriteSize of MV.sprite_sizes) {
        if(url.indexOf(spriteSize.name) != -1) {
            w = spriteSize.wi;
            h = spriteSize.he;
        }
    }

    if(w == -1 && h == -1) {
        loader.image(name, getCdnUrl(url));
    } else {
        loader.spritesheet(name, getCdnUrl(url), Math.floor(w), Math.floor(h));
    }
}

export function madnes_load_atlas(name, imgUrl, jsonUrl, loader = main_phaser.load) {
    loader.atlas(name, getCdnUrl(imgUrl), getCdnUrl(jsonUrl));
}

export function madnes_load_bitmap_font(name, imgUrl, xmlUrl, loader = main_phaser.load) {
    loader.bitmapFont(name, getCdnUrl(imgUrl), getCdnUrl(xmlUrl));
}

function getCdnUrl(url) {
    if (MV.systemConfig.get(CONFIG_PARAMS.URL_CDN) && !isLocalhost()) {
        url = url.replace("assets/","");
        if (url.includes("framework")) {
            return MV.systemConfig.get(CONFIG_PARAMS.URL_CDN) + getUrl(url);
        } else {
            return MV.systemConfig.get(CONFIG_PARAMS.URL_CDN) + getGameId() +  getUrl(url);
        }
    } else {
        return getUrl(url);
    }
}

function getGameId() {
    return MV.systemConfig.get(CONFIG_PARAMS.GAME_ID) + "/";
}